import request from "@/utils/oms-request";
import download from "@/utils/oms-download";

// 壳体包装列表查询
export const search = (params: any) =>
    request({
        url: `/shell-package`,
        method: "get",
        params,
    });

// 壳体包装详情
export const detail = (params: any) =>
    request({
        url: `/shell-package/shell-package-details`,
        method: "get",
        params,
    });

// 删除单条壳体包装
export const deleteOne = (params: any) =>
    request({
        url: `/shell-package`,
        method: "delete",
        params,
    });

// 更新壳体包装
export const update = (data: any) =>
    request({
        url: `/shell-package/shell-package-details`,
        method: "post",
        data,
    });

// 新增壳体包装
export const create = (data: any) =>
    request({
        url: `/shell-package`,
        method: "post",
        data,
    });

// 批量删除壳体包装
export const batchDelete = (data: any) =>
    request({
        url: `/shell-package/batch`,
        method: "delete",
        data,
    });

// 上传维护壳体包装资料
export const upload = (data: any) =>
    request({
        url: `/shell-package/upload`,
        method: "put",
        data,
    });

// 下载壳体包装资料
export const downloadShellPackage = (params: any) =>
    download({
        responseType: "blob",
        url: `/shell-package/download`,
        method: "get",
        params,
    });

// 单个采购订单匹配壳体包装
export const purchaseOrderMatch = (params: any) =>
    request({
        url: `/shell-package/purchase-order/match`,
        method: "get",
        params,
    });

// 采购订单批量匹配壳体包装
export const purchaseOrderBatchMatch = (data: any) =>
    request({
        url: `/shell-package/purchase-orders/batch-match`,
        method: "post",
        data,
    });

// 保存匹配的壳体包装
export const savePurchaseOrderShellPackages = (data: any) =>
    request({
        url: `/shell-package/purchase-order-shell-packages`,
        method: "put",
        data,
    });

// 首次创建壳体包装
export const firstUploadShellPackage = (data: any) =>
    request({
        url: `/shell-package/first/upload`,
        method: "put",
        data
    });

// 下单管理匹配壳体包装获取所需信息
export const getMatchShellPackageInfo = (id: string) =>
    request({
        url: `/proforma-invoices/${id}/purchase-orders/match-shell-package`,
        method: "get",
    });

// 获取采购订单壳体包装资料
export const queryPoShellPackage = (params) =>
    request({
        url: `/shell-package/purchase-order`,
        method: "get",
        params,
    });